import React from 'react';
import { motion } from 'framer-motion';
const tomi = [{
  num: '01',
  tag: '6 Tomi PDF',
  title: 'Il Percorso Completo',
  desc: "Tomo 1: Progettazione Strategica e UDA MIM. Tomo 2: Grammatica e Sintassi Dinamica. Tomo 3: Dalle Radici al Rinascimento con Dante, Petrarca e Boccaccio. Tomo 4: Dall'Illuminismo al Verismo con Foscolo, Manzoni e Leopardi. Tomo 5: Il Novecento e la Contemporaneità con Montale, Pirandello e Svevo. Tomo 6: Laboratorio di Scrittura e Maturità con Tipologia A, B e C."
}, {
  num: '02',
  tag: 'Conforme MIM',
  title: 'Registro del Programma',
  desc: "La soluzione definitiva alla burocrazia: Checklist Indicazioni Nazionali MIM per monitorare l'avanzamento del programma in 5 minuti."
}, {
  num: '03',
  tag: 'Pronto per LIM',
  title: 'Slide Letteratura Visiva',
  desc: 'Lezioni interattive che trasformano Dante, Leopardi e Pirandello in mappe visive immediate, perfette per la lavagna interattiva.'
}, {
  num: '04',
  tag: 'BES e DSA',
  title: 'Recupero e Inclusione',
  desc: 'Schede di recupero rapido pre-verifica e strumenti semplificati conformi alla Legge 170 per non lasciare indietro nessuno studente.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-282">
      <div className="max-w-5xl mx-auto" data-id="element-283">
        <div className="text-center mb-8" data-id="element-284">
          <p className="text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-285">
            Archivio didattico
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-cream mb-3" data-id="element-286">
            Cosa include{' '}
            <span className="text-brand-orange" data-id="element-287">Lettere Pronte</span>
          </motion.h2>
          <p className="text-gray-400 text-sm sm:text-base" data-id="element-288">
            Strumenti digitali in PDF pronti da stampare o proiettare da oggi
            stesso.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-289">
          {tomi.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-290">
              <div className="absolute -right-4 -top-4 text-7xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-291">
                {tomo.num}
              </div>
              <div className="relative z-10" data-id="element-292">
                <div className="inline-block bg-brand-orange text-white text-[10px] font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-293">
                  {tomo.tag}
                </div>
                <h3 className="text-xl font-bold text-brand-cream mb-3 leading-tight" data-id="element-294">
                  {tomo.title}
                </h3>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-295">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}